import { render, staticRenderFns } from "./AllNotifications.vue?vue&type=template&id=7dcccaa4&scoped=true"
import script from "./AllNotifications.vue?vue&type=script&lang=js"
export * from "./AllNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcccaa4",
  null
  
)

export default component.exports